import { get , post } from './api';


// 用户注册
export const userControl = {
	
}

// 首页
export const shouye = {
	// 资源数量
	introduction:() => get("?c=d_home&m=introduction"),
	// 轮播
	banner:() => get("?c=d_home&m=noSetBanner"),
	// 特别推荐
	specail:() => get("?c=d_home&m=noSetSpecial"),
	// 思政活动
	szhdList:(data) => post("?c=d_home&m=noSetSzhd",data),
	// 共享排名
	shareRank:() => get("?c=d_home&m=shareRank"),
	// 优质资源
	excellent:() => get("?c=d_home&m=excellent"),
	// 入住院校
	settle:() => get("?c=d_home&m=settle"),
	// 获奖
	winWorks:() => get("?c=d_home&m=winWorks"),
	// 数字
	number:() => get("?c=d_home&m=param"),
}


// 新闻公告
export  const  news = {
	// 列表
	newMore:(data) => post("?c=d_home&m=noSetMore",data),
}

// 院校风采
export const yxfc = {
	// 学校列表
	settleList:(data) => post("?c=d_home&m=settleList",data),
	// 学校资源
	schooldata:(data) => post("?c=d_home&m=yxfc",data),
}

// 申请入驻
export  const applyIn = {
	// 申请入驻
	applyIn:(data) => post("?c=d_home&m=send_cellphone_code",data),
}


// 思政资源
export const resource = {
	// 资源分类list
	politicsClass:() => get("?c=d_home&m=politicsClass"),
	// 资源列表
	politicsResouce:(data) => post("?c=d_home&m=politicsResouce",data)
}


// 详情
export  const detail = {
	// 示范课详情
	resouceDetail:(data) => post("?c=d_home&m=excellentDetail",data),
	// 其他详情
	politicsDetail:(data) => post("?c=d_home&m=politicsDetail",data),
	// 新闻详情
	newDetail:(data) => post("?c=d_home&m=newDetail",data),
	
	// 非思政库资源详情
	
	// 示范课详情
	resouceDetail1:(data) => post("?c=d_home&m=resouceDetail",data),
	// 其他详情
	politicsDetail1:(data) => post("?c=d_home&m=videoDetail",data),
}

// 数据列表
export const getdata = {
	// 课程思政
	kcszlist:() => get("?c=d_home&m=kcsz"),
	// 课程思政详情
	kcszDetail:(data) => post("?c=d_home&m=kcszDetail",data),
	
	// 思政金课
	szjklist:() => get("?c=d_home&m=szjk"),
	// 思政金课详情
	szjkDetail:(data) => post("?c=d_home&m=szjkDetail",data),
}